import { Component, Input, OnInit, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { Paging } from '@pineapplelab/paging';
import { Table } from 'src/app/models/table';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-mat-table',
  templateUrl: './mat-table.component.html',
  styleUrls: ['./mat-table.component.scss'],
})
export class MatTableComponent implements OnInit, AfterViewInit {
  @Input() table: Table<any> & { paging: Paging<any> };
  @Input() checkColumn: boolean = false;
  @Output() checkBoxSelected = new EventEmitter<any>();
  @Output() isLoading = new EventEmitter<any>();

  displayedColumns: any[];
  dataSource: any;
  selection: any = new SelectionModel<any>(true, []);

  constructor() {}

  ngOnInit() {
    this.displayedColumns = this.table.columns.map((column) => column.label);
    if (this.checkColumn) {
      this.displayedColumns = ['checkColumn'].concat(this.displayedColumns);
    }
  }

  ngAfterViewInit() {
    this.isLoading.emit(false);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.table.paging?.response?.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.table.paging?.response?.data);
  }

  checkboxLabel(row?: any): string {
    this.checkBoxSelected.emit(this.selection.selected);
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }
}
